import React from "react";

const DynamicFilterInput = ({ label, ...props }) => {
  return (
    <div className="col-md">
      {label}
      <input {...props} className="form-control mb-2" />
    </div>
  );
};

export default DynamicFilterInput;
